import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import { MAPBOX_TOKEN } from './mapboxToken'; // Import the token

mapboxgl.accessToken = MAPBOX_TOKEN; // Use the imported token

const MapComponent = ({ services, activeService, resetMap, clearResetMap }) => {
  const mapContainerRef = useRef(null);
  const map = useRef(null);
  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    if (map.current) return; // Initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [-98.5795, 39.8283], // Default center
      zoom: 2.5,
    });

    return () => {
      if (map.current) {
        map.current.remove(); // This properly cleans up the map instance
        map.current = null; // Ensure reference is cleared to prevent memory leaks
      }
    };

    // Event listeners can be adjusted or added here
  }, []);

  // Effect to add markers for all services
  useEffect(() => {
    if (!map.current) return;

    // Clear existing markers
    markers.forEach(marker => marker.remove());
    const newMarkers = [];

    // Add new markers
    services.forEach(service => {
      if (service.coords) {
        const marker = new mapboxgl.Marker()
          .setLngLat([service.coords.longitude, service.coords.latitude])
          .setPopup(new mapboxgl.Popup({ offset: 25 }).setText(`${service.business_name} - ${service.location}`))
          .addTo(map.current);
        newMarkers.push(marker);
      }
    });

    setMarkers(newMarkers);
  }, [services]); // Re-run when services update

  // Effect for resetting map view
  useEffect(() => {
    if (resetMap && map.current) {
      map.current.flyTo({
        center: [-98.5795, 39.8283],
        zoom: 2.5,
      });

      // If provided, call the clearResetMap function to reset the resetMap state in the parent component
      if (clearResetMap) {
        clearResetMap();
      }
    }
  }, [resetMap, clearResetMap]);

  // Effect to handle activeService changes
  useEffect(() => {
    if (!map.current || !activeService || !activeService.coords) return;

    // Fly to the active service location
    map.current.flyTo({
      center: [activeService.coords.longitude, activeService.coords.latitude],
      zoom: 10,
    });

    // Optionally, highlight or otherwise mark the active service's marker here
  }, [activeService]); // Depend on activeService

  useEffect(() => {
    // Cleanup function to remove all markers when the component unmounts
    return () => {
      markers.forEach(marker => marker.remove());
    };
  }, [markers]);

  return (
    <div className="map-container-outer">
      <div ref={mapContainerRef} className="map-container"/>
    </div>
  );
};

export default MapComponent;